import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FleetService } from '../../../core/services/fleet.service';
import { RepairsService } from '../../../core/services/repairs.service';

@Component({
  selector: 'app-single-view-repairs',
  templateUrl: './single-view-repairs.component.html',
  styleUrls: ['./single-view-repairs.component.scss'],
})
export class SingleViewRepairsComponent implements OnInit {
  breadcrumbs: any[] = [];
  fleetId: any;
  repairId: any;
  repairData: any;
  fleetData = {
    _id: ' ',
    vehicleDetails: {
      vehicleModel: '',
      registrationNumber: '',
    },
  };
  paymentAttachments: any[] = [];
  repairsAttachment: any[] = [];
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private fleetService: FleetService,
    private repairService: RepairsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.fleetId = this.route.snapshot.paramMap.get('fleetId');
    this.repairId = this.route.snapshot.paramMap.get('id');

    this.fleetService.getOneFleetById(this.fleetId).then((res) => {
      this.fleetData = res;
      this.setBreadcrumbs();
    });
    this.repairService.getRepairById(this.repairId).then((res) => {
      this.repairData = res;
      console.log(res);
      this.paymentAttachments = res.paymentAttachments;
      this.repairsAttachment = res.repairsAttachment;
      this.setBreadcrumbs();
      this.loading = false;
    });
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'Fleets',
        icon: 'car',
        route: '/admin/fleets',
      },
      {
        title: this.fleetData?.vehicleDetails.registrationNumber,
        route: `/admin/fleets/${this.fleetId}`,
      },
      {
        title: ' Repair ',
        route: [`/admin/fleets/${this.fleetId}`, { pageName: 'fleetRepairs' }],
      },
      {
        title: ` ${this.repairData?.repairId} `,
      },
    ];
  }

  editNavigate(): void {
    const navigationExtras = {
      queryParams: {
        prev: 'single', // Replace 'your_value_here' with the actual value you want to pass
      },
    };

    this.router.navigate(
      [`admin/fleets/${this.fleetId}/repair/add-edit/${this.repairId}`],
      navigationExtras,
    );
  }
}
